import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class EquipFieldData extends BaseBus
{
    constructor(busObj: EquipFieldData = null) {
        super(busObj);
        if (busObj !== null) {
            this.insertDt = DateFunctions.getDate(this.insertDt);
            this.updateDt = DateFunctions.getDate(this.updateDt);
        }
    }
    CID(): any {
        return this.equipFieldDataId;
    }

 equipFieldDataId: any;
 equipmentId: any;
 col1Data: string;
 col2Data: string;
 col3Data: string;
 col4Data: string;
 col5Data: string;
 col6Data: string;
 col7Data: string;
 col8Data: string;
 col9Data: string;
 col10Data: string;
 equipImg: any;
 equipDocUrl: string;
 insertDt: Date;
 insertUserId: any;
 updateDt: Date;
 updateUserId: any;
}
